import { Router } from '@angular/router';
import { appInjector } from '../app-injector';
import { validatePromise } from './decorator-util';

export function navigateOnSuccess(
    routeCommands: any[] | (() => any[])
): MethodDecorator {
    return function (_target, _propertyKey, descriptor: PropertyDescriptor) {
        const fn = descriptor.value;
        descriptor.value = function (...args: any[]) {
            const router = appInjector().get(Router);

            const promise = validatePromise(fn, this, args);
            return promise.then((...args2) => {
                const computedRouteCommands =
                    routeCommands instanceof Function
                        ? routeCommands.call(this)
                        : routeCommands;
                router.navigate(computedRouteCommands);
                return args2;
            });
        };
    };
}
